import { getAuthToken } from "@/lib/auth";

export const ADMIN_KEY_STORAGE = "bk_admin_passcode";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const request = async (path, options = {}) => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || "İşlem tamamlanamadı.");
  return data;
};

export const getAdminHeaders = () => ({});

export const adminLogin = async (passcode) => {
  if (passcode !== "6580") throw new Error("Yanlış şifre");
  return { ok: true };
};

export const fetchCategories = async (opts = {}) => {
  const params = opts.includeHidden ? "?includeHidden=true" : "";
  return request(`/categories${params}`);
};

export const fetchCategory = async (id) => {
  return request(`/categories/${id}`);
};

export const fetchFacts = async (categoryId, opts = {}) => {
  const params = new URLSearchParams();
  if (opts.onlyTrue === true) params.set("only_true", "true");
  if (opts.onlyTrue === false) params.set("only_true", "false");
  const qs = params.toString() ? `?${params.toString()}` : "";
  return request(`/categories/${categoryId}/facts${qs}`);
};

export const getErrorReports = async () => {
  return request("/admin/error-reports");
};

export const getLogicReports = async () => {
  return request("/admin/logic-reports");
};

export const getFactSuggestions = async () => {
  return request("/admin/fact-suggestions");
};

export const getUserStats = async () => {
  return request("/admin/users");
};

export const getTestSessions = async () => {
  return request("/admin/test-sessions");
};

export const resetStatistics = async () => {
  return request("/admin/statistics", {
    method: "DELETE",
  });
};

export const recordTestAnswer = async ({ factId, isCorrect }) => {
  return request("/test/answers", {
    method: "POST",
    body: JSON.stringify({
      fact_id: factId,
      is_correct: isCorrect,
    }),
  });
};

export const recordTestSession = async (payload) => {
  return request("/test/sessions", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const reportFactError = async ({ fact }) => {
  return request("/error-reports", {
    method: "POST",
    body: JSON.stringify({ fact_id: fact?.id }),
  });
};

export const reportFactLogicIssue = async ({ fact }) => {
  return request("/logic-reports", {
    method: "POST",
    body: JSON.stringify({ fact_id: fact?.id }),
  });
};

export const submitFactSuggestion = async (payload) => {
  return request("/fact-suggestions", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const deleteErrorReport = async (reportId) => {
  return request(`/admin/error-reports/${reportId}`, {
    method: "DELETE",
  });
};

export const deleteLogicReport = async (reportId) => {
  return request(`/admin/logic-reports/${reportId}`, {
    method: "DELETE",
  });
};

export const approveFactSuggestion = async (suggestionId) => {
  return request(`/admin/fact-suggestions/${suggestionId}/approve`, {
    method: "POST",
  });
};

export const rejectFactSuggestion = async (suggestionId) => {
  return request(`/admin/fact-suggestions/${suggestionId}`, {
    method: "DELETE",
  });
};

export const createCategory = async (payload) => {
  return request("/admin/categories", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const updateCategory = async (id, payload) => {
  return request(`/admin/categories/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const deleteCategory = async (id) => {
  return request(`/admin/categories/${id}`, {
    method: "DELETE",
  });
};

export const createFact = async (payload) => {
  return request("/admin/facts", {
    method: "POST",
    body: JSON.stringify(payload),
  });
};

export const updateFact = async (id, payload) => {
  return request(`/admin/facts/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
};

export const deleteFact = async (id) => {
  return request(`/admin/facts/${id}`, {
    method: "DELETE",
  });
};

export const bulkImportFacts = async (items) => {
  let added = 0;
  let skipped = 0;
  const categories = await fetchCategories({ includeHidden: true });
  const categoryByName = new Map(
    categories.map((category) => [category.name.toLowerCase(), category])
  );

  for (const item of items) {
    const categoryName = item.kategori?.trim();
    const text = item.text?.trim();
    if (!categoryName || !text) {
      skipped++;
      continue;
    }

    let category = categoryByName.get(categoryName.toLowerCase());
    if (!category) {
      category = await createCategory({ name: categoryName, description: "" });
      categoryByName.set(categoryName.toLowerCase(), category);
    }

    await createFact({
      category_id: category.id,
      text,
      is_true: item.is_true === true,
    });
    added++;
  }

  return { added, skipped };
};

export const exportBackup = async () => {
  return request("/backup");
};

export const importBackup = async (backup) => {
  return request("/backup", {
    method: "POST",
    body: JSON.stringify(backup),
  });
};
